import {httpClient} from '@/http/client'
import {Holiday, HolidayQueryForm} from "@/domain/holiday";
import {Tag} from "@/domain/tag";
import {Department, DepartmentQueryForm} from "@/domain/department";
import {ApproverGroup, ApproverGroupQueryForm} from "@/domain/approver";
import {EmployeeInfo} from "@/domain/companyStructure";
import {EmployeePositionInfo, EmployeePositionQueryForm} from "@/domain/employee";
import {CountriesInfo} from "@/domain/countries";
import {SysBanksInfo, SysBanksQueryForm, SysDictInfo} from "@/domain/sys";

const departmentBase = "/department"

export const departmentList = (query: DepartmentQueryForm) => httpClient.getPage<Department>(`${departmentBase}`, query)

export const departmentEmployeeList = (query: any) => httpClient.get<Array<EmployeeInfo>>(`${departmentBase}/employee`, query)

export const createDepartment = (data: Department) => httpClient.post(`${departmentBase}`, data)

export const updatedDepartment = (id: number, data: Department) => httpClient.put(`${departmentBase}/${id}`, data)

export const removeDepartment = (id: number) => httpClient.patch(`${departmentBase}/${id}`)


const tagBase = "/tag"

export const tagList = (query: Object) => httpClient.get<Array<Tag>>(`${tagBase}`, {params: query})

export const createTag = (data: Holiday) => httpClient.post(`${tagBase}`, data)

export const updatedTag = (id: number, data: Holiday) => httpClient.put(`${tagBase}/${id}`, data)

export const removeTag = (id: number) => httpClient.patch(`${tagBase}/${id}`)


const holidayBase = "/holiday"

export const holidayList = (query: HolidayQueryForm) => httpClient.get<Array<Holiday>>(`${holidayBase}`, query)

export const createHoliday = (data: Holiday) => httpClient.post(`${holidayBase}`, data)

export const removeHoliday = (id: number) => httpClient.patch(`${holidayBase}/${id}`)


const approverGroupBase = "/approver"

export const approverGroupList = (query: ApproverGroupQueryForm) => httpClient.getPage<ApproverGroup>(`${approverGroupBase}`, query)

export const createApproverGroup = (data: ApproverGroup) => httpClient.post(`${approverGroupBase}`, data)

export const updatedApproverGroup = (id: number, data: ApproverGroup) => httpClient.put(`${approverGroupBase}/${id}`, data)

export const removeApproverGroup = (id: number) => httpClient.patch(`${approverGroupBase}/${id}`)

export const assignApproverGroup = (data: any) => httpClient.put(`${approverGroupBase}/assign`, data)


const positionBase = "/position";

export const positionList = (query: EmployeePositionQueryForm) => httpClient.getPage<EmployeePositionInfo>(`${positionBase}`, query)

export const positionEmployeeList = (query: any) => httpClient.get<Array<EmployeeInfo>>(`${positionBase}/employee`, query)

export const createPosition = (data: EmployeePositionInfo) => httpClient.post(`${positionBase}`, data)

export const updatePosition = (id: number, data: EmployeePositionInfo) => httpClient.put(`${positionBase}/${id}`, data)

export const deletePosition = (id: number) => httpClient.delete(`${positionBase}/${id}`)


const countriesBase = "/countries";

export const countriesList = () => httpClient.get<Array<CountriesInfo>>(`${countriesBase}`)


const bankBase = "/sys/bank";

export const bankList = (query: SysBanksQueryForm) => httpClient.getPage<SysBanksInfo>(`${bankBase}`, query)

export const createBank = (data: SysBanksInfo) => httpClient.post(`${bankBase}`, data)

export const updateBank = (id: number, data: SysBanksInfo) => httpClient.put(`${bankBase}/${id}`, data)

export const deleteBank = (id: number) => httpClient.patch(`${bankBase}/${id}`)


const dictBase = "/sys/dict";

export const dictInfo = (query: SysBanksQueryForm) => httpClient.get<SysDictInfo>(`${dictBase}`, query)

export const updateDict = (data: SysDictInfo) => httpClient.post(`${dictBase}`, data)
